import { default as NonProductionDaysHome } from "./Home";
import { default as NonProductionDaysCalendar } from "./Calendar";
import { default as CopyFromPreviousYear } from "./CopyFromPreviousYear";

export default {
  NonProductionDaysCalendar,
  NonProductionDaysHome,
  CopyFromPreviousYear,
};
